export const HOME_PATH = '/dashboard';
export const DASHBOARD_PATH = '/dashboard';
export const FREELANCERS_PATH = '/freelancers';
export const AUTH_PATH = '/auth';
export const SETTINGS_PATH = '/settings';
export const DOCUMENTS_PATH = '/documents';
export const CLIENTS_PATH = '/clients';
export const PROJECT_OPPORTUNITIES_PATH = '/opportunities/projects';
export const JOB_BOARD_PATH = '/job-board';
